import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import useTheme from '@mui/material/styles/useTheme';
import Drawer from '@mui/material/Drawer';
import Fab from '@mui/material/Fab';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Slider from '@mui/material/Slider';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import SubCard from '../../ui-component/cards/SubCard';
import AnimateButton from '../../ui-component/extended/AnimateButton';
import { SET_BORDER_RADIUS, SET_FONT_FAMILY } from '../../store/actions'; // THEME_RTL
import { gridSpacing } from '../../store/constant';

// assets
import { IconSettings } from '@tabler/icons';

// concat 'px'
function valueText(value) {
    return `${value}px`;
}

const SYSTEM_FONT = `-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`;

//-----------------------|| LIVE CUSTOMIZATION ||-----------------------//

const Customization = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);

    // drawer on/off
    const [open, setOpen] = React.useState(false);
    const handleToggle = () => {
        setOpen(!open);
    };

    // state - border radius
    const [borderRadius, setBorderRadius] = React.useState(customization.borderRadius);
    const handleBorderRadius = (event, newValue) => {
        setBorderRadius(newValue);
    };

    useEffect(() => {
        dispatch({ type: SET_BORDER_RADIUS, borderRadius: borderRadius });
    }, [dispatch, borderRadius]);

    // Componente fica montado globalmente (MainLayout) mas sem UI visível
    // (ver `return <></>` abaixo) - MESMO ASSIM os efeitos rodam a cada
    // mount, então o `default` aqui precisa bater com o valor real de
    // `customization.fontFamily`, senão ele reseta a fonte pra Roboto em
    // toda navegação (foi exatamente o bug daqui antes desse fix).
    let initialFont;
    switch (customization.fontFamily) {
        case `'Inter', sans-serif`:
            initialFont = 'Inter';
            break;
        case `'Poppins', sans-serif`:
            initialFont = 'Poppins';
            break;
        case `'Roboto', sans-serif`:
            initialFont = 'Roboto';
            break;
        case SYSTEM_FONT:
        default:
            initialFont = 'Sistema';
            break;
    }

    // state - font family
    const [fontFamily, setFontFamily] = React.useState(initialFont);
    useEffect(() => {
        let newFont;
        switch (fontFamily) {
            case 'Inter':
                newFont = `'Inter', sans-serif`;
                break;
            case 'Poppins':
                newFont = `'Poppins', sans-serif`;
                break;
            case 'Roboto':
                newFont = `'Roboto', sans-serif`;
                break;
            case 'Sistema':
            default:
                newFont = SYSTEM_FONT;
                break;
        }
        dispatch({ type: SET_FONT_FAMILY, fontFamily: newFont });
    }, [dispatch, fontFamily]);

    return (
        <></>
        // <React.Fragment>
        //     {/* toggle button */}

        //     <Tooltip title="Customização">
        //         <Fab
        //             component="div"
        //             onClick={handleToggle}
        //             size="medium"
        //             variant="string"
        //             color="secondary"
        //             sx={{
        //                 bottom: 0,
        //                 m: 4,
        //                 position: 'fixed',
        //                 right: 20,
        //                 zIndex: (theme) => theme.zIndex.speedDial,
        //                 boxShadow: theme.shadows[8]
        //             }}
        //         >
        //             <AnimateButton type="rotate">
        //                 <IconButton color="inherit" size="large" disableRipple>
        //                     <IconSettings />
        //                 </IconButton>
        //             </AnimateButton>
        //         </Fab>
        //     </Tooltip>

        //     <Drawer
        //         anchor="right"
        //         onClose={handleToggle}
        //         open={open}
        //         PaperProps={{
        //             sx: {
        //                 width: 280
        //             }
        //         }}
        //     >
        //         <PerfectScrollbar component="div">
        //             <Grid container spacing={gridSpacing} sx={{ p: 3 }}>
        //                 <Grid item xs={12}>
        //                     {/* font family */}
        //                     <SubCard title="Todas as fontes">
        //                         <FormControl>
        //                             <RadioGroup
        //                                 aria-label="font-family"
        //                                 value={fontFamily}
        //                                 onChange={(e) => setFontFamily(e.target.value)}
        //                                 name="row-radio-buttons-group"
        //                             >
        //                                 <FormControlLabel
        //                                     value="Roboto"
        //                                     control={<Radio />}
        //                                     label="Roboto"
        //                                     sx={{
        //                                         '& .MuiSvgIcon-root': { fontSize: 28 },
        //                                         '& .MuiFormControlLabel-label': { color: 'grey.900' }
        //                                     }}
        //                                 />
        //                                 <FormControlLabel
        //                                     value="Poppins"
        //                                     control={<Radio />}
        //                                     label="Poppins"
        //                                     sx={{
        //                                         '& .MuiSvgIcon-root': { fontSize: 28 },
        //                                         '& .MuiFormControlLabel-label': { color: 'grey.900' }
        //                                     }}
        //                                 />
        //                                 <FormControlLabel
        //                                     value="Inter"
        //                                     control={<Radio />}
        //                                     label="Inter"
        //                                     sx={{
        //                                         '& .MuiSvgIcon-root': { fontSize: 28 },
        //                                         '& .MuiFormControlLabel-label': { color: 'grey.900' }
        //                                     }}
        //                                 />
        //                             </RadioGroup>
        //                         </FormControl>
        //                     </SubCard>
        //                 </Grid>
        //                 <Grid item xs={12}>
        //                     {/* border radius */}
        //                     <SubCard title="Borda dos cards arredondada">
        //                         <Grid item xs={12} container spacing={2} alignItems="center" sx={{ mt: 2.5 }}>
        //                             <Grid item>
        //                                 <Typography variant="h6" color="secondary">
        //                                     4px
        //                                 </Typography>
        //                             </Grid>
        //                             <Grid item xs>
        //                                 <Slider
        //                                     size="small"
        //                                     value={borderRadius}
        //                                     onChange={handleBorderRadius}
        //                                     getAriaValueText={valueText}
        //                                     valueLabelDisplay="on"
        //                                     aria-labelledby="discrete-slider-small-steps"
        //                                     marks
        //                                     step={2}
        //                                     min={4}
        //                                     max={24}
        //                                     color="secondary"
        //                                     sx={{
        //                                         '& .MuiSlider-valueLabel': {
        //                                             color: 'secondary.light'
        //                                         }
        //                                     }}
        //                                 />
        //                             </Grid>
        //                             <Grid item>
        //                                 <Typography variant="h6" color="secondary">
        //                                     24px
        //                                 </Typography>
        //                             </Grid>
        //                         </Grid>
        //                     </SubCard>
        //                 </Grid>
        //             </Grid>
        //         </PerfectScrollbar>
        //     </Drawer>
        // </React.Fragment>
    );
};

export default Customization;
